<template>
  <div class="origin-info" id="origin-info">
    <div class="section-header">
      <img class="header-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115161810A012.png" alt="">
      <div class="header-title">产地信息</div>
      <img class="header-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115161810A012.png" alt="">
    </div>

    <div class="map-section">
      <div class="map-header">
        <div class="map-title">基础信息</div>
        <div class="altitude-info">海拔范围：{{ originData.altitude }}米</div>
      </div>
      <div class="map-container-wrapper">
        <div class="map-container" ref="mapContainer">
          <div v-if="loading" class="map-loading">
            <div class="loading-spinner"></div>
            地图加载中...
          </div>
          <div v-if="mapError" class="map-error">
            地图加载失败，请检查网络连接
            <button @click="retryLoadMap">重试</button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="map-section">
      <div class="map-header">
        <div class="map-title">环境信息</div>
      </div>
      
      <!-- 天气信息显示 -->
      <div class="weather-info" v-if="weatherData">
        <div class="weather-basic">
          <!-- <div class="weather-icon" v-if="weatherData.icon">
            <img :src="getWeatherIcon(weatherData.icon)" alt="天气图标" class="weather-icon-img">
          </div> -->
          <div class="weather-text">{{ weatherData.text || '暂无天气数据' }}</div>
          <div class="weather-temp">{{ weatherData.temp || '--' }}℃</div>
        </div>
        
        <div class="weather-details">
          <div class="weather-detail-item">
            <div class="detail-label">风速</div>
            <div class="detail-value">{{ weatherData.windSpeed || '--' }}公里/小时</div>
          </div>
          <div class="weather-detail-item">
            <div class="detail-label">湿度</div>
            <div class="detail-value">{{ weatherData.humidity || '--' }}%</div>
          </div>
          <div class="weather-detail-item">
            <div class="detail-label">气压</div>
            <div class="detail-value">{{ weatherData.pressure || '--' }}hPa</div>
          </div>
          <div class="weather-detail-item">
            <div class="detail-label">体感温度</div>
            <div class="detail-value">{{ weatherData.feelsLike || '--' }}℃</div>
          </div>
        </div>
        
        <div class="weather-extra" v-if="weatherData.obsTime">
          <div class="update-time">观测时间：{{ formatTime(weatherData.obsTime) }}</div>
        </div>
      </div>
      
      <!-- 天气数据加载状态 -->
      <div v-if="weatherLoading" class="weather-loading">
        <div class="loading-spinner small"></div>
        天气数据加载中...
      </div>
      
      <div v-if="weatherError && !weatherData" class="weather-error">
        天气数据加载失败
        <button @click="getWeather" class="retry-btn">重试</button>
      </div>
    </div>
    
    <!-- 坐标调试信息 -->
    <!-- <div v-if="showDebug" class="debug-info">
      <h4>坐标调试信息</h4>
      <p>原始坐标: {{ rawCoordinate || '无' }}</p>
      <p>解析后: 经度={{ originData.lng }}, 纬度={{ originData.lat }}</p>
      <p>点击坐标: {{ clickedCoordinate || '未点击' }}</p>
    </div> -->
  </div>
</template>

<script>
/* global qq */
import productApi from '@/api/modules/product'

export default {
  name: 'OriginInfo',
  props: {
    batch: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      map: null,
      originData: {
        baseId: '10001',
        altitude: '450',
        lat: 28.8582, // 默认值，避免为0
        lng: 119.0206 // 默认值，避免为0
      },
      loading: false,
      mapError: false,
      showDebug: false, // 调试模式，生产环境设为false
      rawCoordinate: '',
      clickedCoordinate: '',
      weatherStations: [
        { id: '1241561' },
        { id: '1241562' },
        { id: '1241563' }
      ],
      mapInitialized: false,
      resizeTimer: null,
      
      // 天气相关数据
      weatherData: null,
      weatherLoading: false,
      weatherError: false
    }
  },
  mounted() {
    // 初始化地图
    this.initMapWithRetry();
    // 获取天气数据
    this.getWeather();
  },
  beforeDestroy() {
    // 清理
    window.removeEventListener('resize', this.handleWindowResize);
    if (this.map) {
      // 销毁地图实例
      this.map = null;
    }
  },
  methods: {
    // 重试加载地图
    retryLoadMap() {
      this.mapError = false;
      this.initMapWithRetry();
    },
    
    // 带重试的地图初始化
    async initMapWithRetry(retryCount = 0) {
      // 最大重试次数
      const MAX_RETRY = 3;
      
      // 1. 等待腾讯地图API加载
      if (typeof qq === 'undefined' || !qq.maps) {
        if (retryCount < MAX_RETRY) {
          console.log(`等待腾讯地图API加载，重试 ${retryCount + 1}/${MAX_RETRY}`);
          setTimeout(() => this.initMapWithRetry(retryCount + 1), 1000);
          return;
        } else {
          console.error('腾讯地图API加载失败');
          this.mapError = true;
          return;
        }
      }
      
      // 2. 获取产品数据
      try {
        await this.getProductData();
      } catch (error) {
        console.error('获取产品数据失败:', error);
        // 即使获取数据失败，也使用默认坐标初始化地图
      }
      
      // 3. 确保DOM渲染完成
      this.$nextTick(() => {
        // 检查容器是否存在且可见
        if (!this.$refs.mapContainer) {
          console.error('地图容器不存在');
          this.mapError = true;
          return;
        }
        
        // 检查容器尺寸
        const container = this.$refs.mapContainer;
        const rect = container.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) {
          console.warn('地图容器尺寸为0，等待布局完成');
          setTimeout(() => this.initMapWithRetry(), 300);
          return;
        }
        
        // 初始化地图
        this.initMap();
      });
    },
    
    // 获取天气信息数据
    async getWeather() {
      try {
        this.weatherLoading = true;
        this.weatherError = false;
        
        const response = await productApi.getWeather();
        
        if (response.success && response.data) {
          this.weatherData = response.data;
          
          // 检查是否有必要的数据字段，如果没有，使用示例数据
          if (!this.weatherData.text) {
            console.warn('天气数据返回格式异常，使用示例数据');
            this.weatherData = {
              text: '多云',
              temp: '8',
              windSpeed: '2',
              humidity: '24',
              pressure: '980',
              feelsLike: '7',
              obsTime: new Date().toISOString(),
              icon: '104'
            };
          }
          
          console.log('天气数据获取成功:', this.weatherData);
        } else {
          console.error('获取天气数据失败:', response.msg || '未知错误');
          // 使用示例数据
          this.useSampleWeatherData();
        }
      } catch (error) {
        console.error('获取天气数据失败:', error);
        this.weatherError = true;
        // 使用示例数据
        this.useSampleWeatherData();
      } finally {
        this.weatherLoading = false;
      }
    },
    
    // 使用示例天气数据
    useSampleWeatherData() {
      this.weatherData = {
        text: '多云',
        temp: '8',
        windSpeed: '2',
        humidity: '24',
        pressure: '980',
        feelsLike: '7',
        obsTime: new Date().toISOString(),
        icon: '104'
      };
    },
    
    // 根据天气代码获取天气图标
    getWeatherIcon(iconCode) {
      // 这里可以根据不同的icon代码返回不同的图标URL
      // 示例：使用心知天气的图标，您可以根据实际情况替换
      if (!iconCode) return 'https://s1.sencdn.com/web/icons/3d_50/100.png';
      
      return `https://s1.sencdn.com/web/icons/3d_50/${iconCode}.png`;
    },
    
    // 格式化时间
    formatTime(timeString) {
      if (!timeString) return '--';
      
      try {
        const date = new Date(timeString);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return timeString;
      }
    },
    
    // 获取产地信息数据
    async getProductData() {
      try {
        this.loading = true;
        const response = await productApi.getPlaceList({
          pageNum: 1,
          pageSize: 20,
          batch: this.batch
        });
        
        if (response.success && response.data && response.data.records && response.data.records.length > 0) {
          const placeData = response.data.records[0];
          this.rawCoordinate = placeData.coordinate || '';
          
          // 处理经纬度坐标
          if (placeData.coordinate) {
            this.processCoordinate(placeData.coordinate);
          } else {
            console.warn('产地数据中没有坐标信息，使用默认坐标');
            this.originData.lat = 28.8582;
            this.originData.lng = 119.0206;
          }
        } else {
          console.warn('未获取到产地数据，使用默认坐标');
        }
      } catch (error) {
        console.error('获取产地数据失败:', error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    
    // 处理坐标字符串（关键修正）
    processCoordinate(coordinate) {
      if (!coordinate || typeof coordinate !== 'string') {
        console.error('坐标数据无效:', coordinate);
        return;
      }
      
      try {
        // 去除空格
        const cleanCoord = coordinate.trim();
        
        // 分割字符串
        const parts = cleanCoord.split(',').map(part => {
          const num = parseFloat(part.trim());
          return isNaN(num) ? null : num;
        }).filter(part => part !== null);
        
        if (parts.length !== 2) {
          console.error('坐标格式错误，应为"经度,纬度"或"纬度,经度":', coordinate);
          return;
        }
        
        // 关键：确定坐标顺序
        // 后台返回的是"经度,纬度"格式（腾讯地图标准）
        let lng = parts[0];
        let lat = parts[1];
        
        // 验证坐标是否合理（中国范围内）
        const isInChinaRange = lng >= 73 && lng <= 135 && lat >= 18 && lat <= 54;
        
        if (!isInChinaRange) {
          console.warn('坐标超出中国范围，尝试交换顺序');
          // 尝试交换顺序（可能是"纬度,经度"格式）
          [lng, lat] = [lat, lng];
          
          // 再次验证
          const swappedIsValid = lng >= 73 && lng <= 135 && lat >= 18 && lat <= 54;
          if (!swappedIsValid) {
            console.error('坐标值异常:', parts, '请检查数据源格式');
            // 使用默认坐标
            lng = 119.0206;
            lat = 28.8582;
          }
        }
        
        // 赋值
        this.originData.lng = lng;
        this.originData.lat = lat;
        
        console.log('坐标解析完成:', {
          原始坐标: coordinate,
          解析结果: { lng, lat }
        });
        
      } catch (e) {
        console.error('解析坐标失败:', e);
        // 使用默认坐标
        this.originData.lng = 119.0206;
        this.originData.lat = 28.8582;
      }
    },
    
    // 初始化地图
    initMap() {
      try {
        // 防止重复初始化
        if (this.mapInitialized) {
          console.log('地图已初始化，跳过');
          return;
        }
        
        const { lat, lng } = this.originData;
        
        // 确保经纬度有效
        if (lat === 0 && lng === 0) {
          console.error('经纬度无效，无法初始化地图');
          this.mapError = true;
          return;
        }
        
        console.log('初始化地图，中心点坐标:', { lat, lng });
        
        // 创建地图实例
        this.map = new qq.maps.Map(this.$refs.mapContainer, {
          center: new qq.maps.LatLng(lat, lng), // 注意：参数顺序是(纬度, 经度)
          zoom: 19, // 调整缩放级别，放大到能看到月山村委会
          mapTypeId: qq.maps.MapTypeId.HYBRID,
          disableDefaultUI: false, // 启用默认UI控件
          zoomControl: false, // 显示缩放控件
          zoomControlOptions: {
            position: qq.maps.ControlPosition.RIGHT_CENTER
          },
          scrollwheel: true, // 启用鼠标滚轮缩放
          disableDoubleClickZoom: false, // 启用双击缩放
          draggable: true // 保持可拖拽功能
        });
        
        // 添加中心点标记
        const marker = new qq.maps.Marker({
          position: new qq.maps.LatLng(lat, lng),
          map: this.map,
          title: '产地位置',
          animation: qq.maps.MarkerAnimation.DROP // 添加动画效果
        });
        
        // 添加信息窗口
        const infoWindow = new qq.maps.InfoWindow({
          map: this.map
        });
        
        // 标记点击事件
        qq.maps.event.addListener(marker, 'click', () => {
          infoWindow.open();
          infoWindow.setContent(`
            <div style="padding: 10px;">
              <h4 style="margin: 0 0 5px 0;">产地位置</h4>
              <p style="margin: 0;">纬度: ${lat.toFixed(6)}</p>
              <p style="margin: 0;">经度: ${lng.toFixed(6)}</p>
              <p style="margin: 5px 0 0 0;">海拔: ${this.originData.altitude}米</p>
            </div>
          `);
          infoWindow.setPosition(marker.getPosition());
        });
        
        // 添加地图点击事件监听器（关键修正）
        qq.maps.event.addListener(this.map, 'click', (event) => {
          const latLng = event.latLng;
          const clickedLat = latLng.getLat();
          const clickedLng = latLng.getLng();
          
          // 保存点击的坐标
          this.clickedCoordinate = `经度: ${clickedLng.toFixed(6)}, 纬度: ${clickedLat.toFixed(6)}`;
          
          // 格式化为后台需要的字符串（腾讯地图标准：经度,纬度）
          const coordinateForBackend = `${clickedLng.toFixed(6)},${clickedLat.toFixed(6)}`;
          
          console.log('地图点击位置:', {
            纬度: clickedLat,
            经度: clickedLng,
            后台格式: coordinateForBackend
          });
          
          // 可以在这里调用API保存坐标
          // this.saveCoordinateToBackend(coordinateForBackend);
          
          // 移除点击位置添加临时标记的功能
        });
        
        // 添加地图加载完成事件
        qq.maps.event.addListener(this.map, 'tilesloaded', () => {
          console.log('地图瓦片加载完成');
          this.mapInitialized = true;
          
          // 确保地图正确显示
          this.$nextTick(() => {
            if (this.map) {
              // 触发地图重绘，解决显示不全问题
              setTimeout(() => {
                this.map.panBy(0, 0);
                // 修复地图显示不全的问题
                this.forceMapResize();
                
                // 再次强制重绘，确保左侧灰色区域消失
                setTimeout(() => {
                  if (this.map) {
                    this.forceMapResize();
                  }
                }, 200);
              }, 100);
            }
          });
        });
        
        // 添加窗口大小变化监听
        window.addEventListener('resize', this.handleWindowResize);
        
        // 添加地图容器resize监听
        this.setupResizeObserver();
        
        console.log('地图初始化成功');
        
      } catch (error) {
        console.error('地图初始化失败:', error);
        this.mapError = true;
        this.mapInitialized = false;
      }
    },
    
    // 强制地图重新计算尺寸
    forceMapResize() {
      if (!this.map) return;
      
      try {
        // 临时改变地图容器尺寸，触发地图重绘
        const container = this.$refs.mapContainer;
        if (container) {
          // 方法1: 强制触发地图resize事件
          qq.maps.event.trigger(this.map, 'resize');
          
          // 方法2: 微调地图中心点，强制重绘
          setTimeout(() => {
            if (this.map) {
              const center = this.map.getCenter();
              // 先稍微移动一下中心点
              this.map.setCenter(new qq.maps.LatLng(center.getLat() + 0.00001, center.getLng()));
              // 再移回原来的中心点
              setTimeout(() => {
                if (this.map) {
                  this.map.setCenter(center);
                }
              }, 50);
            }
          }, 50);
          
          // 方法3: 重新设置地图大小
          setTimeout(() => {
            if (this.map) {
              // 获取容器的实际尺寸
              const rect = container.getBoundingClientRect();
              if (rect.width > 0 && rect.height > 0) {
                // 强制地图重新计算尺寸
                this.map.setOptions({ 
                  center: this.map.getCenter(),
                  zoom: this.map.getZoom()
                });
              }
            }
          }, 100);
        }
      } catch (e) {
        console.warn('地图resize触发失败:', e);
      }
    },
    
    // 设置ResizeObserver监听容器尺寸变化
    setupResizeObserver() {
      if (!this.$refs.mapContainer || !window.ResizeObserver) return;
      
      try {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        
        this.resizeObserver = new ResizeObserver(() => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => {
            this.handleMapResize();
          }, 200);
        });
        
        this.resizeObserver.observe(this.$refs.mapContainer);
      } catch (e) {
        console.warn('ResizeObserver初始化失败:', e);
      }
    },
    
    // 处理地图容器尺寸变化
    handleMapResize() {
      if (this.map && this.mapInitialized) {
        try {
          // 修复地图显示不全的问题
          this.forceMapResize();
        } catch (e) {
          console.error('地图resize处理失败:', e);
        }
      }
    },
    
    // 处理窗口大小变化
    handleWindowResize() {
      if (this.map && this.mapInitialized) {
        // 使用防抖避免频繁触发
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          try {
            // 触发地图重绘
            this.handleMapResize();
          } catch (e) {
            console.error('窗口resize处理失败:', e);
          }
        }, 300);
      }
    },
    
    // 保存坐标到后台（示例方法）
    async saveCoordinateToBackend(coordinate) {
      try {
        // 这里调用你的后台API
        // const response = await productApi.saveCoordinate({
        //   baseId: this.originData.baseId,
        //   coordinate: coordinate
        // });
        console.log('保存坐标到后台:', coordinate);
        // 可以添加成功提示
      } catch (error) {
        console.error('保存坐标失败:', error);
      }
    }
  }
}
</script>

<style scoped>
.origin-info {
  padding: 0;
  margin-bottom: 120px;
  width: 100%;
  box-sizing: border-box;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  width: 100%;
}

.header-icon {
  width: 20px;
  height: 20px;
  margin: 0 10px;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}

.base-tag {
  display: inline-block;
  background: #DFFFF2;
  font-size: 14px;
  color: #02A863;
  padding: 8px 18px;
  border-radius: 20px;
  font-weight: 500;
}

.map-section {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  overflow: hidden; /* 防止内容溢出导致宽度问题 */
}

.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  width: 100%;
  box-sizing: border-box;
}

.map-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.altitude-info {
  font-size: 14px;
  color: #333;
  padding: 4px 12px;
  border-radius: 15px;
}

/* 关键修复：添加wrapper确保地图容器正确显示 */
.map-container-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 0 0 8px 8px;
  /* 确保wrapper有明确的尺寸 */
  min-height: 350px;
}

.map-container {
  position: relative;
  width: 100%;
  height: 350px; /* 固定高度，使地图显示更完整 */
  background-color: #f5f5f5;
  /* 移除border-radius，在wrapper上设置 */
  /* 移除overflow: hidden，让地图能正确绘制 */
  /* 确保容器尺寸在初始化时就正确 */
  box-sizing: border-box;
}

.map-loading, .map-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 10;
  color: #666;
  font-size: 14px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #02A863;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.loading-spinner.small {
  width: 20px;
  height: 20px;
  border-width: 2px;
  margin-bottom: 0;
  margin-right: 8px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.map-error button {
  margin-top: 10px;
  padding: 6px 16px;
  background-color: #02A863;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.map-error button:hover {
  background-color: #028a52;
}

/* 天气信息样式 - 已修改为紧凑布局 */
.weather-info {
  padding: 12px 16px;
}

.weather-basic {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.weather-text {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.weather-temp {
  font-size: 18px;
  font-weight: bold;
  color: #02A863;
}

.weather-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 改为两列 */
  gap: 10px; /* 减小间隙 */
  margin-bottom: 10px; /* 减小底部间距 */
}

.weather-detail-item {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 8px 10px; /* 减小内边距 */
  display: flex;
  flex-direction: column;
}

.detail-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 3px;
}

.detail-value {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.weather-extra {
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.update-time {
  font-size: 11px;
  color: #888;
  text-align: center;
}

.weather-loading, .weather-error {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #666;
  font-size: 14px;
}

.weather-error {
  flex-direction: column;
}

.retry-btn {
  margin-top: 8px;
  padding: 5px 12px;
  background-color: #02A863;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
}

.retry-btn:hover {
  background-color: #028a52;
}

.debug-info {
  margin-top: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border-left: 4px solid #02A863;
  font-size: 14px;
}

.debug-info h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
}

.debug-info p {
  margin: 5px 0;
  color: #666;
}

/* 确保地图元素正确显示 */
.map-container :deep(.qq-map-container) {
  width: 100% !important;
  height: 100% !important;
}

.map-container :deep(.qq-map-canvas) {
  width: 100% !important;
  height: 100% !important;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .weather-details {
    grid-template-columns: repeat(2, 1fr); /* 保持两列 */
    gap: 8px;
  }
  
  .weather-basic {
    flex-direction: column;
    text-align: center;
    margin-bottom: 10px;
  }
  
  .weather-text {
    margin-bottom: 5px;
  }
  
  .weather-info {
    padding: 10px 12px;
  }
}
</style>